import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
    return (
        <>
            <Header />
            <section className="terms-section">
                <Container className="terms-container">
                    <h4 className="mb-4">Privacy Policy</h4>

                    <div className="terms-content">
                        <h5>1. Introduction</h5>
                        <p>
                            This Privacy Policy outlines how we collect, use, and protect your information when you use our platform. By accessing or using our services, you agree to the terms outlined in this policy.
                        </p>

                        <h5>4. Data Sharing and Storage</h5>
                        <p>
                            We do not sell your personal data. However, we may share information with trusted third-party services for:
                        </p>

                        <h5>5. Security</h5>
                        <p>
                            We implement appropriate security measures including encryption, secure servers, and access controls to protect your data. However, no system is 100% secure, and we encourage you to use strong passwords and protect your account.
                        </p>

                        <h5>6. Cookies and Tracking</h5>
                        <p>
                            We use cookies and similar technologies to track user activity, remember preferences, and enhance your browsing experience. You can manage cookie settings in your browser.
                        </p>

                        <h5>7. Data Retention</h5>
                        <p>
                            We retain your data as long as your account is active or as needed to provide services, comply with our legal obligations, resolve disputes, and enforce agreements.
                        </p>

                        <h5>8. Your Rights</h5>
                        <p>
                            You have the right to access, update, delete, or restrict the use of your personal information. To exercise these rights, please contact us at <a href="mailto:support@example.com">support@example.com</a>.
                        </p>

                        <h5>9. Changes to This Policy</h5>
                        <p>
                            We may update this Privacy Policy from time to time. We will notify you of significant changes by email or by posting a notice on our website.
                        </p>

                        <h5>10. Contact Us</h5>
                        <p>
                            If you have any questions or concerns regarding this Privacy Policy, please contact us at:
                            <br />
                            <strong>Email:</strong> support@example.com<br />
                            <strong>Address:</strong> 1234 Editing Lane, Creative City, CA 90210
                        </p>
                    </div>
                </Container>
            </section>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
